






































import { Vue, Component } from 'vue-property-decorator';
import Table from '@/components/Table/Index.vue';
import { getModule } from 'vuex-module-decorators';
import CurrencyData from '@/data/CurrencyData';
import CurrencyModule from '@/store/modules/Currency';
import GeneralModule from '@/store/modules/General';

@Component({
  components: {
    Table,
  },
})
export default class CurrencyRateView extends Vue {
  TableHead = CurrencyData.TableHead;

  CurrencyInstance = getModule(CurrencyModule, this.$store);

  GeneralInstance = getModule(GeneralModule, this.$store);

  currency: any = []

  isCrypto = false

  created() {
    this.fetchCurrency();
  }

  handleCrypto() {
    this.isCrypto = !this.isCrypto;
    this.fetchCurrency();
  }

  async fetchCurrency() {
    this.GeneralInstance.toggleLoading(true);
    const res = await this.CurrencyInstance.fetchCurrencyRate({ data: { currency: '' } });
    this.currency = res.rateCurrency;
    this.GeneralInstance.toggleLoading(false);
  }
}
